import kengurLogo from '../assets/kengur_with_logo.jpg';
import math from '../assets/math.png';
import mathjpg from '../assets/math.jpg';

import tree from '../assets/tree.png';
import whiteTree from '../assets/white_tree.png';

import waveImage from '../assets/images/wave.png';
import waveImage2 from '../assets/images/wave_blue.png';
import bgImage from '../assets/images/bg.svg';
import formulas from '../assets/formulas.png';
import kengur from '../assets/kengur.png';
import ilustration1 from '../assets/ilustration1.jpg';
import ilustration2 from '../assets/ilustration2.jpg';
import ilustration3 from '../assets/ilustration3.jpg';
import ilustration4 from '../assets/ilustration4.jpg';
import ilustration8 from '../assets/Ilustration7.png';
import noData from '../assets/noData.jpg';
import noData2 from '../assets/noData2.png';
import noData3 from '../assets/noData3.png';
import mathBackground from '../assets/mathBackground.jpg';
import complaint from '../assets/complaint.jpg';

export const ImageUrl = {
  kengurWithLogo: kengurLogo,
  kengur: kengur,
  formulas: formulas,
  math: math,
  mathjpg: mathjpg,
  tree: tree,
  whiteTree: whiteTree,
  bg: bgImage,
  wave: waveImage,
  wave2: waveImage2,
  ilustration1: ilustration1,
  ilustration2: ilustration2,
  ilustration3: ilustration3,
  ilustration4: ilustration4,
  ilustration8: ilustration8,
  noData: noData,
  noData2: noData2,
  noData3: noData3,
  mathBackground: mathBackground,
  complaint: complaint
};
